<section translate="no">
    <main>
    <section class="pesq-section div_orientacao">

      <form class="form-class" data-toggle="collapse" (ngSubmit)="MudaFiltro()">
        <div class="div_busca_orientacao">
          <div class="item_pesquisa">
            <div class="form-div p-3">
              <label for="pesquisaCodigo" class="form-label">Codigo:</label>
              <input type="text" class="form-control" placeholder="Codigo" id="pesquisaCodigo" name="pesquisaCodigo"
                [(ngModel)]="pesquisaCodigo" required>
            </div>
          </div>
          <div class="item_pesquisa">
            <div class="form-div p-3">
              <label for="pesquisaCodCentralizado" class="form-label">Codigo Centralizado:</label>
              <input type="text" class="form-control" placeholder="Codigo Centralizado" id="pesquisaCodCentralizado"
                name="pesquisaCodCentralizado" [(ngModel)]="pesquisaCodCentralizado" required>
            </div>
          </div>
          <div class="item_pesquisa">
            <div class="form-div p-3">
              <label for="pesquisaDesc" class="form-label">Descrição:</label>
              <input type="text" class="form-control" placeholder="Descrição" id="pesquisaDesc" name="pesquisaDesc"
                [(ngModel)]="pesquisaDesc" required>
            </div>
          </div>
          
          <div class="d-flex align-items-center gap-2">
            <div class="div-button mb-3 p-3">
              <button type="submit" class="btn btn-primary btnpesquisa">Pesquisar</button>
            </div>
          
            <div class="div-button mb-3 p-3">
              <button type="submit" class="btn btn-success" [routerLink]="['/trocar-posicao-orgao']">Mudar ordenação</button>
            </div>
          </div>

          @if(validarRole() == true){
          <div class="btnplus"  [ngClass]="{'subeButtonAdd': subeButtonAdd}"  style="position: fixed; bottom: 13px; right: 22px;">
            <a [routerLink]="['/orgao-cadastro']"><button id="class-button"
                style="border-radius: 50%;width: 45px;height: 45px;" class="btn btn-success"><i
                  class="fas fa-plus"></i></button></a>
          </div>
          }

        </div>
      </form>

    </section>
    <!--Tabela -->
    <section class="main-section-table">
      <div class="tabela-wrapper">
      <table class="table">
        <!--toJsonBody-->
        <thead>

          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Codigo Centralizado</th>
            <th scope="col">Descrição</th>
            <th scope="col">Nome de Apresentação</th>
            @if(validarRole() == true){
            <th scope="col">Funções</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (p of listaOrg; track $index) {
          <tr>
            <td style="font-weight: bold;">{{p.codigo}}</td>
            <td>{{p.codigoCentralizado}}</td>
            <td>{{p.descricao}}</td>
            <td>{{p.nomeApresentacao}}</td>
            @if(validarRole() == true){
            <td><a class="btn btn-primary" style="margin-right: 10px;" [routerLink]="['/orgao-cadastro']"
                [queryParams]="{IdEditar: p.id}">Editar</a>
              <button class="btn btn-danger" (click)="excluirItem(p.id)">Excluir</button>
              @if(validarRoleSuper() == true){
              <a [routerLink]="['/auditoria-listagem']"
                [queryParams]="{id: p.codigoCentralizado, tabela: 'Orgao'}"><button class="btn btn-secondary"
                  style="margin-left: 10px;"><i class="fas fa-history"></i></button></a>
              }
            </td>
            }


          </tr>
          }
        </tbody>
      </table>
    </div>

      <mat-paginator #paginator class="demo-paginator" (page)="handlePageEvent($event)" [length]="totalPages"
        [pageSize]="pageSize" [disabled]="disabled" [showFirstLastButtons]="showFirstLastButtons"
        [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true" [pageIndex]="pageIndex" aria-label="Select page">
      </mat-paginator>
    </section>


  </main>
  <div style="height: 150px;">
  </div>
</section>